/**
 * 聊天历史本地缓存(localStorage)—— 仅用于"进 Chat 秒显",不是真相来源。
 *
 * stale-while-revalidate:进 Chat 先读缓存立即渲染(消除空白闪烁),同时照常拉服务器最新;
 * 拉回后服务器数据替换显示 + 覆盖缓存。所以多设备一致性不受影响(服务器永远赢)。
 *
 * 按 username 分键,避免同浏览器多账号串味。容量很小(只缓存最近若干条)。
 */

import { getSession } from './auth'

export interface CachedMessage {
    id: number
    role: 'user' | 'assistant'
    content: string
}

const MAX = 60 // 只留最近 N 条,防止长会话把 localStorage 撑大

function cacheKey(): string | null {
    const username = getSession()?.username
    return username ? `chat_history_${username}` : null
}

export function loadHistoryCache(): CachedMessage[] | null {
    const key = cacheKey()
    if (!key) return null
    try {
        const raw = localStorage.getItem(key)
        if (!raw) return null
        const arr = JSON.parse(raw)
        return Array.isArray(arr) ? (arr as CachedMessage[]) : null
    } catch {
        return null
    }
}

export function saveHistoryCache(messages: CachedMessage[]): void {
    const key = cacheKey()
    if (!key) return
    try {
        localStorage.setItem(key, JSON.stringify(messages.slice(-MAX)))
    } catch {
        /* 配额满 / 隐私模式:静默忽略,缓存只是优化 */
    }
}
